import { SVGProps } from "react";

const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M12.98 10a2.98 2.98 0 0 1-2.983 2.983A2.98 2.98 0 0 1 7.014 10a2.98 2.98 0 0 1 2.983-2.983A2.98 2.98 0 0 1 12.98 10Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M10.002 16.892c2.941 0 5.683-1.734 7.591-4.734.75-1.175.75-3.15 0-4.325-1.908-3-4.65-4.733-7.591-4.733-2.942 0-5.684 1.733-7.592 4.733-.75 1.175-.75 3.15 0 4.325 1.908 3 4.65 4.734 7.592 4.734Z"
    />
  </svg>
);
export default Eye;
